var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMostLikedDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.691 13.7501C19.9199 13.7501 19.0479 13.8314 18.215 14.1153C13.1936 15.7548 11.5792 21.1175 12.9984 25.5374L13.0044 25.556L13.0109 25.5744C13.7929 27.7718 15.0528 29.7658 16.6916 31.4061L16.7011 31.4155L16.7107 31.4248C19.0472 33.6654 21.5906 35.6191 24.3445 37.3144L24.9917 37.7128L25.6433 37.3216C28.4032 35.6643 30.9955 33.6567 33.3039 31.4342L33.3112 31.4273L33.3183 31.4202C34.9713 29.7768 36.2313 27.768 37.0018 25.5686L37.0082 25.5502L37.0141 25.5316C38.4064 21.1213 36.8001 15.7522 31.8133 14.1368C30.9969 13.8652 30.1544 13.7501 29.3309 13.7501C27.4784 13.7501 26.1072 14.5258 25.0004 15.3163C23.9023 14.5318 22.5219 13.7501 20.691 13.7501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostLikedDecor);
export default __webpack_public_path__ + "static/media/most-liked-decor.3a2ee407f3c44970d1980f16dfb5c37f.svg";
export { ForwardRef as ReactComponent };